import { render, staticRenderFns } from "./ressources.vue?vue&type=template&id=28376966&scoped=true"
import script from "./ressources.vue?vue&type=script&lang=js"
export * from "./ressources.vue?vue&type=script&lang=js"
import style0 from "./ressources.vue?vue&type=style&index=0&id=28376966&prod&scoped=true&lang=css"
import style1 from "./ressources.vue?vue&type=style&index=1&id=28376966&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28376966",
  null
  
)

export default component.exports